export default __webpack_public_path__ + "static/media/Foundation_popup.d0270162.png";